import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

const serviceTypeQueryMap = {
  without_driver: { order_type_id: 1, support_driver: false },
  with_driver: { order_type_id: 1, support_driver: true },
  airport_transfer: { order_type_id: 2, support_driver: true },
  airport_transfer_sg: { order_type_id: 7, support_driver: true },
};

export const getReviews = createAsyncThunk('reviews/getReviews', async (payload, thunkAPI) => {
  const { page, order_number, rating, service } = payload;

  const mappedService = serviceTypeQueryMap[service] || {};

  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', '10');
  if (order_number) params.append('order_number', order_number);
  if (rating) params.append('rate', rating);
  if (mappedService.order_type_id !== undefined) {
    params.append('order_type_id', mappedService.order_type_id);
  }
  if (mappedService.support_driver !== undefined) {
    params.append('support_driver', mappedService.support_driver);
  }

  try {
    const response = await axiosInstance.get(`/reviews?${params.toString()}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('failed to get review data!');
  }
});

export const getReviewById = createAsyncThunk('reviews/getReviewById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/reviews/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('failed to get review detail!');
  }
});

export const getReviewByOrder = createAsyncThunk('reviews/getReviewByOrder', async (transaction_key, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/orders/${transaction_key}/reviews`);

    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('failed to get review data!');
  }
});

export const sendReviewReply = createAsyncThunk('reviews/sendReviewReply', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/reply-review`, payload);

    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('failed to reply!');
  }
});

export const updateReviewVisibility = createAsyncThunk('reviews/updateReviewVisibility', async (payload, thunkAPI) => {
  const { id, data } = payload;

  try {
    const response = await axiosInstance.put(`/admin/reviews/${id}`, data);

    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('failed to update review!');
  }
});

export const deleteReview = createAsyncThunk('reviews/deleteReview', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/reviews/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('failed to delete review!');
  }
});
